import {Flex} from "antd";
import {translations} from "./Translations";
import {getLangFromUrl} from "./Header";
import "./main.css";

export const About = () => {
    const lang = getLangFromUrl();

    const items = [
        {title: translations[lang].about1Tag, background: "#ffe8f7", color: "#f409a1"},
        {title: translations[lang].about2Tag, background: "#d3f2ff", color: "#0b9ed9"},
        {title: translations[lang].about3Tag, background: "#f1deff", color: "#a44ee0"},
    ];
    return (
        <div>
        <div style={{position: 'relative'}}>
            <div style={{
                margin: "0 auto",
                background: 'url("/1200.png")',
                backgroundSize: 'contain',
                backgroundRepeat: 'repeat',
                position: "absolute",
                width: "100%",
                height: "100%",
                zIndex: -1,
            }}></div>
            <Flex style={{margin: "0 auto", maxWidth: 1200, padding: "40px 0 60px 0"}} vertical={true} align={'center'}>
                <div className="games-section-title">{translations[lang].about}</div>
                <Flex className="about-cards" style={{whiteSpace: 'pre-wrap', width: "100%"}} gap={20}>
                    <Flex
                        vertical={true}
                        className={"about-card"}
                        style={{flex: 1, padding: 40, textAlign: 'center'}}
                        gap={20}
                        align={'center'}
                    >
                        <div className="about-card__title">{translations[lang].about1Title}</div>
                        <div className={"icon"}>
                            <img src={"/dices.svg"} style={{width: 130, height: 130}}/>
                        </div>
                        <div className="about-card__body">{translations[lang].about1Text}</div>
                        <div className="about-card__tags">
                            <Flex align={'center'} gap={5} className="tag" style={{
                                background: items[0].background,
                                color: items[0].color
                            }}><CheckIcon/>{items[0].title}</Flex>
                        </div>
                    </Flex>
                    <Flex
                        vertical={true}
                        className={"about-card"}
                        style={{flex: 1, padding: 40, textAlign: 'center'}}
                        gap={20} align={'center'}
                    >
                        <div className="about-card__title">{translations[lang].about2Title}</div>
                        <img src={"/properties.png"} style={{width: 130, height: 130}}/>
                        <div className="about-card__body">{translations[lang].about2Text}</div>
                        <div className="about-card__tags">
                            <Flex align={'center'} gap={5} className="tag" style={{
                                background: items[1].background,
                                color: items[1].color
                            }}><CheckIcon/>{items[1].title}</Flex>
                        </div>
                    </Flex>
                    <Flex
                        vertical={true}
                        className={"about-card"}
                        style={{flex: 1, padding: 40, textAlign: 'center'}}
                        align={'center'}
                        gap={20}
                    >
                        <div className="about-card__title" >{translations[lang].about3Title}</div>
                        <img src={"/group.png"} style={{width: 130, height: 130}}/>
                        <div className="about-card__body">{translations[lang].about3Text}</div>
                        <div className="about-card__tags">
                            <Flex align={'center'} gap={5} className="tag" style={{
                                background: items[2].background,
                                color: items[2].color
                            }}><CheckIcon/>{items[2].title}</Flex>
                        </div>
                    </Flex>
                </Flex>
            </Flex>


        </div>

        </div>
    )
}

function CheckIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill={"none"}>
            <circle cx="12" cy="12" r="10" fill="currentColor"/>

            <path
                d="M7 12.5L10.5 16L17 9"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}